import { createFileRoute } from '@tanstack/react-router';

// import { PlayPage } from '@/features/play-page/index';
// import { FontComparisonDemo } from '@/features/workout-creator/ui/v2/demos/font-comparison-demo';

function PlayPage() {
	return <div>PlayPage</div>;
}

export const Route = createFileRoute('/play')({
	component: PlayPage,
});
